<div class="pricing-backdrop">
  <div class="pricing-modal">

	 <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="top-icon">
  <i class="bi bi-lock"></i>
    </div>

    <h2 class="title text-center">{{data.title}}</h2>
    <p class="text-center">{{data.message}}</p>

    <button class="btn-add w-100" [routerLink]="'/student-dashboard/upgrade-plan'">Upgrade Now</button>
  </div>
</div>